import React from "react";
import { Route, Routes } from "react-router-dom";
import "assets/css/main.scss";
import Home from "home/home";
import Header from "base/header/header";
import Footer from "base/footer/footer";
import Contact from "base/contact/contact";
export default function App() {
  return (
    <>
      <Header />
      <main className="main">
        <Routes>
          <Route path="" element={<Home />} />
        </Routes>
      </main>
      <Contact />
      <Footer />
    </>
  );
}

// npm start -- --host --port 80
